import React from 'react';

export class CreditReasonDropdown extends React.Component {
    render() {
        return (
            <React.Fragment>
                {this.props.creditReasons.length === 1 &&
                    <span style={{ marginRight: '20px' }} >{this.props.creditReasons[0].portalDescription}</span>
                }
                {this.props.creditReasons.length > 1 &&
                    <select style={{ color: 'black', marginRight: '10px' }} onChange={this.props.onChangeCreditReason}
                        value={this.props.creditReasonCode} name={this.props.creditReasonCode}
                    >
                        {this.props.creditReasons.map((cr) =>
                            <option key={cr.creditReasonCode} value={cr.creditReasonCode}>{cr.portalDescription}</option>
                        )}
                    </select>
                }
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Report/CreditReasonDropdown.js